/**
 * Date della richiesta: stagione natalizia, oggi in formato ISO, data leggibile.
 *
 * Tutto puro e con la data passata dall'esterno: il componente legge «oggi» una
 * sola volta (useState) e i test possono fissare qualunque giorno.
 */

/** Il giorno corrente. Funzione e non costante: si legge solo dove serve. */
export function nowDate(): Date {
  return new Date();
}

/**
 * «Natale {anno}» compare dal 1° settembre al 15 dicembre: è il periodo in cui le
 * aziende pianificano i regali di fine anno. Fuori stagione non c'è.
 */
export function seasonFor(today: Date): { christmas: boolean; year: number } {
  const m = today.getMonth(); // 0 = gennaio
  const d = today.getDate();
  const christmas = m >= 8 && (m < 11 || (m === 11 && d <= 15));
  return { christmas, year: today.getFullYear() };
}

/** «YYYY-MM-DD» nel fuso locale: è il formato di `<input type="date">` e del suo `min`. */
export function isoDay(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const INTL: Record<string, string> = { it: "it-IT", en: "en-GB", de: "de-DE" };

export function intlLocale(lang: string): string {
  return INTL[lang] ?? "en-GB";
}

/**
 * «20 novembre 2026» / «20 November 2026» / «20. November 2026».
 * La data dell'input è un giorno di calendario: si interpreta in UTC per non
 * scivolare al giorno prima nei fusi negativi.
 */
export function formatDay(iso: string, lang: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return "";
  const date = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(intlLocale(lang), { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(date);
}
